import { render, staticRenderFns } from "./UserCallAvatar.vue?vue&type=template&id=24cc42e7&scoped=true&"
import script from "./UserCallAvatar.vue?vue&type=script&lang=js&"
export * from "./UserCallAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserCallAvatar.vue?vue&type=style&index=0&id=24cc42e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc42e7",
  null
  
)

export default component.exports